/* eslint-disable react/prop-types */
/* eslint-disable react/react-in-jsx-scope */
import { Card, Col, Empty, Popover, Row, Space, Spin, Table, Tag, Typography, message } from 'antd';
import { useEffect, useReducer, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Content } from 'antd/es/layout/layout';
// import eventsImg from '../../images/Events.png';
import dashboarddatareducer from './reducer';
import { GRADE_LIST, GRADE_LIST_ERROR, GRADE_LIST_SUCCESS, NOTIFICATION_MANAGEMENT_LIST, NOTIFICATION_MANAGEMENT_LIST_ERROR, NOTIFICATION_MANAGEMENT_LIST_SUCCESS, STS_DASHBOARD_LIST, STS_DASHBOARD_LIST_ERROR, STS_DASHBOARD_LIST_SUCCESS } from './constants';
import moment from 'moment';
import lw from '../../images/person-walking-arrow-right-solid.svg';
import totallw from '../../images/people-group-solid.svg';
import totalnpv from '../../images/car-on-solid.svg';
import compinsp from '../../images/person-circle-check-solid.svg';
import tottalinsp from '../../images/people-arrows-solid.svg';
import reporticon from '../../images/clipboard-solid-full.svg';
import attendanceicon from '../../images/person-circle-exclamation-solid-full.svg';
import speedlimiticon from '../../images/speed-limit.png';
import chainageicon from '../../images/lost.png';
import nosignalicon from '../../images/no-wifi.png';
import geofenceicon from '../../images/radar.png';
import nosignaluser from '../../images/nosignaluser.png';
import nodata from '../../images/nodata.png';
import englan from '../../english.json';
import germanlan from '../../german.json';
import arabiclan from '../../arabic.json';
import frenchlan from '../../french.json';
import hindilan from '../../hindi.json';
import malayalamlan from '../../malayalam.json';
import QRT from '../../images/QRT.svg';
import {datetimeCovertertolocal} from '../datetime-converter';

// import { TLP_DASHBOARD_LIST, TLP_DASHBOARD_LIST_ERROR, TLP_DASHBOARD_LIST_SUCCESS } from './constants';
// import moment from 'moment';



export default function StsContent (props) {

	
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const navigate = useNavigate();
	const initalState = {grade_data: [],stsfilter : [] ,stsdashboarddata : null, details: null, pending: false, error: false, pagination: { total: 0, limit: 10, skip: 0, current:1 } };
	const [stsData, dispatch] = useReducer(dashboarddatareducer, initalState);
	const [count,setCount]  = useState(0);
	const regionId = props.regionId;
	const date = props.date;
	const view = props.view;
	const usertypeId = props.usertypeId;
	// const [allocationId, setAllocationId] = useState(null);
	const startdatetime = moment.utc(date.setHours(0,0,0,0)).toISOString();
	const enddatetime = moment.utc(date.setHours(23,59,59,999)).toISOString();

	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const admin_roles = ['superadmin','admin','Station-In-Charge','Pipeline-HO','Pipeline-In-Charge','HQO-HSE'];
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);

	const envRefreshTime = process.env.REACT_APP_REFRESH_TIME == undefined || process.env.REACT_APP_REFRESH_TIME == 'undefined' ? 180000 : process.env.REACT_APP_REFRESH_TIME;
	const refreshTime = localStorage.getItem(`${dashboardtype.toUpperCase()}_REFRESH_TIME`) == 'null' ? parseInt(envRefreshTime) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_REFRESH_TIME`));

	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const envdateformat = process.env.REACT_APP_DATE_FORMAT == undefined || process.env.REACT_APP_DATE_FORMAT == 'undefined' ? 'YYYY-MM-DD' : process.env.REACT_APP_DATE_FORMAT;
	const settingsdateformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'undefined' ? envdateformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`);
	let Gradedata = [];


	stsData.grade_data && stsData.grade_data.map((item) => {

		
		const minStartTime = datetimeCovertertolocal(item ? item.inspectionSummary.minStart : '<Not Set>');
		const newMinStart = item && item.inspectionSummary.minStart ? (minStartTime.localdate + ' ' + minStartTime.localtime) : '<Not Set>';
		const maxEndTime = datetimeCovertertolocal(item ? item.inspectionSummary.maxEnd : '<Not Set>');
		const newMaxEnd = item && item.inspectionSummary.maxEnd ? (maxEndTime.localdate + ' ' + maxEndTime.localtime) : '<Not Set>';

		const currTime = datetimeCovertertolocal(item ? item?.lastlocation?.lastLocation?.currenttimestamp : '<Not Set>');
		const newCurrTime = item && item?.lastlocation?.lastLocation?.currenttimestamp ? (currTime.localdate + ' ' + currTime.localtime) : '<Not Set>';
		Gradedata.push({
			key: item.id,
			id: item.id,
			name: item.userName,
			totaldistance:item.totalDistance ? item.totalDistance.toFixed(2):0 ,
			covereddistance:item.coveredDistance ? item.coveredDistance.toFixed(2) : 0,
			avgvelocity: parseFloat(item.avgVelocity).toFixed(2),
			coverage: parseFloat(item.coverage).toFixed(2)+ ' ' +'%',
			rawcoverage: item.coverage,
			regionId : item?.regioninfoId ? item?.regioninfoId : null,
			chainageFrom : item?.userAllocation &&  item?.userAllocation?.regioninfo && item?.userAllocation?.regioninfo?.startChainage,
			chainageTo : item?.userAllocation &&  item?.userAllocation?.regioninfo && item?.userAllocation?.regioninfo?.endChainage,
			inspectionIds : item?.inspectionIds ? item?.inspectionIds : null,
			coveredChainages : item?.patchdetails &&  item?.patchdetails?.coveredChainages ? item?.patchdetails?.coveredChainages : null, 
			pipelineId : item?.pipelineId ? item?.pipelineId : null,
			itemdate :moment.utc(item?.date).local().format(settingsdateformat), 
			idletime: item.idleTime.toFixed(2),
			speedviolation: item.speedViolation,
			systemgrade: item.systemGrade,
			finalgrade:item.finalGrade,
			remarks:item.remarks,
			totalTravelledDist:item.totalTravelledDist ? item.totalTravelledDist : 0,
			minStart : newMinStart,
			maxEnd : newMaxEnd,
			latestStatus : item.inspectionSummary.latestStatus ? item.inspectionSummary.latestStatus : '',
			vehicleNumber : item.vehiclemanagement ? item.vehiclemanagement.vehicleNumber : 'N/A',
			batteryVoltage : item.vehiclemanagement ? item.vehiclemanagement.batteryVoltage : 'N/A',
			imeiNumber : item.vehiclemanagement ? item.vehiclemanagement.imeiNumber : 'N/A',
			allocationId : item?.allocationId ? item.allocationId : '',
			lastlocation : item?.lastlocation ? item?.lastlocation?.lastChainage : 'N/A',
			lastlatitude : item?.lastlocation ?  item?.lastlocation?.lastLocation?.latitude : 'N/A',
			lastLongitude : item?.lastlocation ?  item?.lastlocation?.lastLocation?.longitude : 'N/A',
			time : newCurrTime,
			currentSpeed : item?.lastlocation ?  item?.lastlocation?.lastLocation?.velocity : 'N/A',
			distance : item?.lastlocation ?  item?.lastlocation?.distance.toFixed(4) : 'N/A',
			userId : item?.userId ?  item?.userId: '',
			latestInspectionId : item?.inspectionSummary &&  item.inspectionSummary.latestInspectionId ? item.inspectionSummary.latestInspectionId  :null

		});
					
	});

	let allocationParams = '';
	if(admin_roles.includes(permission)){
		allocationParams = regionId ? `&regioninfoId=${regionId}` : '';
	}
	else{
		allocationParams = regionId ? `&allocationId=${regionId}` : '';
	}
	useEffect(() => {
		if(!authtoken){
			navigate('/');
		}
		getStsData();
		loadSTSFilter();
		if(view == 'List'){
			getGrade(1);
		}
		if(view == 'Tile'){
			getCount();
		}
	},[authtoken, regionId, date, view, usertypeId]);

	useEffect(() => {
		const interval = setInterval(() => {
			// getStsData();
			navigate(0);
		}, refreshTime ); 
		return () => clearInterval(interval);
	}, []);

	const getCount  =  () =>{
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/nosignalusers?utc_min=${startdatetime}&utc_max=${enddatetime}${allocationParams}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			},
			data: {
  
			}
		};
		axios
			.request(config)
			.then((response) => {
				setCount(response?.data?.data?.length);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const getStsData = () =>{

		dispatch({ type : STS_DASHBOARD_LIST});
		
		

		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/stsdashboard?${allocationParams}=${regionId}&startDatetime=${startdatetime}&endDatetime=${enddatetime}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			},
			data: {
  
			}
		};
  
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type:STS_DASHBOARD_LIST_SUCCESS, payload:response.data});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({type:STS_DASHBOARD_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
				// setDropOpen(false);
				// setOpen(true);
				// setErrorMessasge(error.response.data.message);
			});
	};

	const loadSTSFilter = ()=>{
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/stsnotificationtype/?pipelineId=${pipelineId}&$sort[id]=1`,
			timeout: timeout,
			headers: {
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			},
		};
		dispatch({type : NOTIFICATION_MANAGEMENT_LIST});
		axios.request(config)
			.then((response) => {
				if(response.status == 200 || response.status == 201){
					dispatch({ type : NOTIFICATION_MANAGEMENT_LIST_SUCCESS, payload: response.data.data });
				} else {
					dispatch({ type : NOTIFICATION_MANAGEMENT_LIST_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : NOTIFICATION_MANAGEMENT_LIST_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				} else {
					// Modal.warning({ title: langdata && langdata.Unabletoupdatealgorithm ? langdata.Unabletoupdatealgorithm : 'Unable to update algorithm.' });
				}
			});
	};

	const lookup = Object.fromEntries(
		stsData.stsfilter.map(item => [item.label, item.id])
	);
	

	const  	handleNaviagte =(e)=>{

		

		if(e=='linewalker'){
			navigate(( '/allocations'),{ state: { data: {params:'', value:4, regionId : regionId}, path: 'dashboard' } });
			localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , '5');
		}
		else if(e=='inspections'){
			navigate(( '/inspections'),{ state: { data: {params:'', value:0, regionId : regionId, startdatetime : date, enddatetime : date}, path: 'dashboard' } });
			localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , '66');
		}
		else if(e=='npv'){
			navigate(( '/allocations'),{ state: { data: {params:'', value:7, regionId : regionId }, path: 'dashboard' } });
			localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , '5');
		}
		else if(e=='Inprogress'){
			navigate(( '/inspections'),{ state: { data: {params:'&status=Inprogress', value:0, regionId : regionId, startdatetime : date, enddatetime : date}, path: 'dashboard' } });
			localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , '66');
		}
		else if(e=='Completed'){
			navigate(( '/inspections'),{ state: { data: {params:'&status=Completed', value:0, regionId : regionId, startdatetime : date, enddatetime : date}, path: 'dashboard' } });
			localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , '66');
		}
		else if(e=='gradereport'){
			navigate(( '/grade-system'),{ state: { data: {regionId : regionId, startdatetime : startdatetime}, path: 'dashboard' } });
			localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , '65');
		}
		else if(e=='totalnosignal'){
			navigate(('/notifications'),{state: {data : {regionId : regionId, startdatetime : date, enddatetime : date,params :'', value : lookup['No Signal'],dashBoardType : 'sts'}}});
		}
		else if(e=='missedchainages'){
			navigate(('/notifications'), {state:{data :{regionId : regionId, startdatetime: date, enddatetime : date, params: '' , value :lookup['Missed Chainages'], dashBoardType: 'sts'}}});
		}
		else if(e=='attendencedeviation'){
			navigate(('/notifications'), {state:{data :{regionId : regionId, startdatetime: date, enddatetime : date, params: '' , value :lookup['Attendance Deviation'], dashBoardType: 'sts'}}});
		}
		else if(e=='geofencedeviation'){
			navigate(('/notifications'), {state:{data :{regionId : regionId, startdatetime: date, enddatetime : date, params: '' , value :lookup['Geofence Deviation'], dashBoardType: 'sts'}}});
		}
		else if(e=='speedviolation'){
			navigate(('/notifications'), {state:{data :{regionId : regionId, startdatetime: date, enddatetime : date, params: '' , value :lookup['Speed Violation'], dashBoardType: 'sts'}}});
		}
		else if(e=='qrt'){
			navigate(( '/allocations'),{ state: { data: {params:'', value:13, regionId : regionId }, path: 'dashboard' } });
			localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , '5');
		}else if(e=='nosignal'){
			navigate(('/no-signal-users'),{state: {data : {regionId : regionId, startdatetime : date, enddatetime : date,params :'', value : lookup['No Signal'],dashBoardType : 'sts'}}});
		}else if(e=='nodata'){
			navigate(('/notifications'),{state: {data : {regionId : regionId, startdatetime : date, enddatetime : date,params :'', value : lookup['No Data'],dashBoardType : 'sts'}}});
		}
		
	};

	const inspectiondetailsHandler = (record)=>{
		const inspection = {
			name: record?.name,
			id:record?.latestInspectionId,
			date: record?.itemdate,
			regioninfoId: record?.regionId,
		};
		navigate(('/inspection-details'),{ state: { data: inspection, path: 'inspections' }});
	};

	const columns = [
		{
			title: `${langdata && langdata.Name ? langdata.Name:'Name'}`,
			dataIndex: 'name',
			key: 'name',
			//   render: (_,text) => <a onClick={showEditDrawer}>{text}</a>)

			render: (_,record) => (
				<Space size="middle">
					<a onClick={() => {inspectiondetailsHandler(record);}}>{record.name}</a>
					{/* <a title="Delete TLP Rule" onClick={showDeleteTLPRuleModal}><CloseOutlined /></a> */}
				</Space>
			)

		},
		{
			title: `${langdata && langdata.TotalDistance ? langdata.TotalDistance:'Total Distance (km)'}`,
			dataIndex: 'totaldistance',
			key: 'totaldistance',
		},
		{
			title: `${langdata && langdata.CoveredDistance ? langdata.CoveredDistance:'Covered Distance (km)'}`,
			dataIndex: 'covereddistance',
			key: 'covereddistance',
		},
		{
			title: `${langdata && langdata.AvgVelocity ? langdata.AvgVelocity:'Avg Velocity (km/h)'}`,
			dataIndex: 'avgvelocity',
			key: 'avgvelocity',
		},
		{
			title: `${langdata && langdata.Coverage ? langdata.Coverage:'Coverage'}`,
			dataIndex: 'coverage',
			key: 'coverage',
			render : (_,record)=>(
				record.rawcoverage <= 0 ? record.rawcoverage :
					<a onClick={() => {navigate(('/patch-details'),{ state:{ data :{ userId: record.userId, regioninfoId: record.regionId, chainageFrom: record.chainageFrom ,chainageTo: record.chainageTo, inspectionIds: record.inspectionIds, coveredChainages: record.coveredChainages, name:record.name, itemdate: record.itemdate, pipelineId: record.pipelineId}, path: 'patch'} });}}>{record.coverage}</a>
			),
		},
		{
			title: `${langdata && langdata.IdleTime ? langdata.IdleTime:'Idle Time (min)'}`,
			dataIndex: 'idletime',
			key: 'idletime',
		},
		{
			title: `${langdata && langdata.SpeedViolation ? langdata.SpeedViolation:'Speed Violation'}`,
			dataIndex: 'speedviolation',
			key: 'speedviolation',
		},
		{
			title: `${langdata && langdata.TotalTraveledDistance ? langdata.TotalTraveledDistance:'Total Traveled Distance (km)'}`,
			dataIndex: 'totalTravelledDist',
			key: 'totalTravelledDist',
		},
		{
			title: `${langdata && langdata.Vehicle ? langdata.Vehicle:'Vehicle'}`,
			dataIndex: 'vehicleNumber',
			key: 'vehicleNumber',
		},
		{
			title:langdata&&langdata.BatteryVoltage?langdata.BatteryVoltage:'Battery Voltage',
			dataIndex: 'batteryVoltage',
			key: 'batteryVoltage',
			
		},
		{
			title:langdata&&langdata.IMEINumber?langdata.IMEINumber:'IMEI Number',
			dataIndex: 'imeiNumber',
			key: 'imeiNumber',
			
		},
		{
			title: `${langdata && langdata.AllocationId ? langdata.AllocationId:'Allocation Id'}`,
			dataIndex: 'allocationId',
			key: 'allocationId',
			
		},
		{
			title: `${langdata && langdata.StartTime ? langdata.StartTime:'StartTime'}`,
			dataIndex: 'minStart',
			key: 'minStart',
		},
		{
			title: `${langdata && langdata.EndTime ? langdata.EndTime:'End Time'}`,
			dataIndex: 'maxEnd',
			key: 'maxEnd',
		},
		{
			title: `${'Last Location'}`,
			dataIndex: 'lastlocation',
			key: 'lastlocation',
			render: (text,record) => (
				<Popover overlayStyle={{ width : text.length >= 80 ?  '80%' : '' }} title={langdata && langdata.Info ? langdata.Info :'Info'} content={
					<div>
						<p><b>{langdata && langdata.Currentchainage ? langdata.Currentchainage :'Current chainage'} : </b>{text}</p>
						<p><b>{langdata && langdata.Latitude ? langdata.Latitude :'Latitude'} : </b>{record?.lastlatitude}</p>
						<p><b>{langdata && langdata.Longitude ? langdata.Longitude :'Longitude'}  : </b>{record?.lastLongitude}</p>
						<p><b>{langdata && langdata.CurrentVelocitykmh ? langdata.CurrentVelocitykmh :'Current Velocity (km/h)'} : </b>{record.currentSpeed}</p>
						<p><b>{langdata && langdata.Time ? langdata.Time :'Time'} : </b>{(record.time)}</p>
						<p><b>{langdata && langdata.Distancem ? langdata.Distancem :'Distance (m)'} : </b>{(record.distance)}</p>
					</div>
				} trigger="hover">
					<Typography style={{minWidth: '100px'}}
					>
						{/* { text.length >= 80 ? text.slice(0,80) + '...' : text.slice(0,80)} */}
						{record.latestStatus == 'Completed' ? <> {text}</> : <a onClick={() => {navigate(( '/mylinewalker'),{ state: { userId: record.id, lat : record?.lastlatitude, lng : record?.lastLongitude  } });}} >{text}</a>}

						
					</Typography>
				</Popover>
			)
			
		},
		{
			title: `${langdata && langdata.Status ? langdata.Status:'Status'}`,
			dataIndex: 'latestStatus',
			key: 'latestStatus',
			render: (_, { latestStatus }) => (
				<>
					<Tag color={latestStatus === 'Completed' ?'green' :'red'} key={latestStatus}>
						{latestStatus.toUpperCase()}
					</Tag>
				</>
			),
		},
		
      
	];


	let grade_data_pagination = {};

	const getGrade =(pagination)=>{

		let _pagination = { };
		_pagination.total = grade_data_pagination.total ? grade_data_pagination.total : 0;
		_pagination.limit = pagination.pageSize ? pagination.pageSize : 10;
		_pagination.skip =  pagination && pagination.current ? parseInt((pagination.current-1) * pagination.pageSize) : 0;

		localStorage.setItem(`${dashboardtype.toUpperCase()}_PAGE`, pagination && pagination.current ? pagination.current : 1);
		localStorage.setItem(`${dashboardtype.toUpperCase()}_PAGE_SIZE`, pagination && pagination.pageSize ? pagination.pageSize : 10);

		let allocationParams = '';
		if(admin_roles.includes(permission)){
			allocationParams = regionId ? `&regioninfoId=${regionId}` : '';
		}
		else{
			// allocationParams = allocationId ? `&allocationId=${allocationId}` : '';
		}
		let params='';
		if(usertypeId == 13){
			params = '&usertypeId=13';
		} else if(usertypeId== 4){
			params = '&usertypeId=4';
		} else if(usertypeId == 7){
			params = '&usertypeId=7';
		}

		dispatch({ type : GRADE_LIST});
		// setURL({base: `${api}/gradesystem-list`,params:`date=${date.split('/').reverse().join('-')}${allocationParams}`});
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/gradesystem-list?date=${moment(date).format('DD/MM/YYYY').split('/').reverse().join('-')}${allocationParams}&$limit=${_pagination.limit}&$skip=${_pagination.skip}${params}`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
			data : ''
		};
      
		axios.request(config)
			.then((response) => {
				if (response.status === 200) {
					grade_data_pagination.total = response.data.total ? response.data.total : 0;
					grade_data_pagination.limit = response.data.limit ? response.data.limit : 10;
					grade_data_pagination.skip = response.data.skip ? response.data.skip : 0;
					grade_data_pagination.current = pagination.current ? pagination.current : 1;
					dispatch({ type : GRADE_LIST_SUCCESS, payload : response.data.data});
				}else {
					dispatch({ type : GRADE_LIST_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : GRADE_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});

	};
	return(

		<>
			{view && view ==='Tile' ? (
				<Content>
					<Row gutter={{
						xs: 8,
						sm: 16,
						md: 24,
						lg: 32,
					}} style={{
						marginTop:'20px',
						marginLeft:'0px',
						marginRight:'0px',
						marginBottom: '20px',
					}}>
						<Space>
							<Col onClick={()=>{handleNaviagte('linewalker');}}  style={{marginBottom:'20px'}} span={6}> 
								<Card style={{ minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px', cursor: 'pointer'}} >
									<Card.Grid style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px',}}>
										{/* <Statistic
								title="EVENTS"
								value={activityCount.totalEvents}
								precision={0}
								// valueStyle={{ color: 'green' }}
								prefix={<OneToOneOutlined />}
								suffix=""
								src={eventsImg}
							/> */}
										<Col style={{ display : 'flex', justifyContent : 'center' }}>
											<img shape="square" src={totallw} alt='event image' style={{ height : '35px' }}/>
										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px', textAlign : 'center' }}>
											<Typography>{langdata && langdata ? langdata.TOTALLINEWALKERS: 'TOTAL LINEWALKERS'}</Typography>
										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px' }}>
											<Typography style={{ fontSize : '25px'}}><b> {stsData && stsData.stsdashboarddata ? stsData.stsdashboarddata.totalLineWalkers : 0}</b> </Typography>
										</Col>
									</Card.Grid>
								</Card>
							</Col>
						</Space>
						{ permission != 'CRO' ?
							<Space>
								<Col onClick={()=>{handleNaviagte('npv');}}  style={{marginBottom:'20px'}} span={6}> 
									<Card style={{ minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px', cursor: 'pointer'}} >
										<Card.Grid style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px',}}>
											{/* <Statistic
								title="EVENTS"
								value={activityCount.totalEvents}
								precision={0}
								// valueStyle={{ color: 'green' }}
								prefix={<OneToOneOutlined />}
								suffix=""
								src={eventsImg}
							/> */}
											<Col style={{ display : 'flex', justifyContent : 'center' }}>
												<img shape="square" src={totalnpv} alt='event image' style={{ height : '35px'}}/>
											</Col>
											<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px', textAlign : 'center' }}>
												<Typography>{langdata && langdata ? langdata.TOTALNPVS: 'TOTAL NPVS'}</Typography>
											</Col>
											<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px' }}>
												<Typography style={{ fontSize : '25px'}}><b> {stsData && stsData.stsdashboarddata ? stsData.stsdashboarddata.totalNPVs : 0}</b> </Typography>
											</Col>
										</Card.Grid>
									</Card>
								</Col>
							</Space>
							: null }
						<Space>
							<Col onClick={()=>{handleNaviagte('qrt');}}    style={{marginBottom:'20px'}} span={6}>
								<Card style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px', cursor: 'pointer'}}>
									<Card.Grid style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px',}}>
										{/* <Statistic
								title="ACKNOWLEDGEMENTS"
								value={acknowledgementcount}
								precision={0}
								// valueStyle={{ color: 'crimson' }}
								prefix={<OneToOneOutlined />}
								suffix=""
							/> */}														
										<Col style={{ display : 'flex', justifyContent : 'center' }}>
											<img shape="square" src={QRT} alt='acknowledgement count' style={{ height : '35px' }}/>
										

										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px', textAlign : 'center' }}>
										
											<Typography>{langdata&&langdata.QRT?langdata.QRT:'TOTAL QRT'}</Typography>
										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px' }}>
										
											<Typography style={{fontSize:'25px'}}><b>{stsData && stsData.stsdashboarddata ? stsData.stsdashboarddata.totalQRTs : 0}</b></Typography>
										</Col>
									</Card.Grid>
								</Card>
							</Col>
						</Space>
				
						<Space>
							<Col onClick={()=>{handleNaviagte('inspections');}}  style={{marginBottom:'20px'}} span={6}>
								<Card style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px', cursor: 'pointer'}}>
									<Card.Grid style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px',}}>
										{/* <Statistic
								title="ACKNOWLEDGEMENTS"
								value={acknowledgementcount}
								precision={0}
								// valueStyle={{ color: 'crimson' }}
								prefix={<OneToOneOutlined />}
								suffix=""
							/> */}														
										<Col style={{ display : 'flex', justifyContent : 'center' }}>
											<img shape="square" src={tottalinsp} alt='acknowledgement count' style={{ height : '35px' }}/>

										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px', textAlign : 'center' }}>
											<Typography>{langdata && langdata ? langdata.TOTALINSPECTIONS: 'TOTAL INSPECTIONS'}</Typography>
										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px' }}>
											<Typography style={{ fontSize : '25px'}}><b> {stsData && stsData.stsdashboarddata ? stsData.stsdashboarddata.totalInspections :0}</b> </Typography>
										</Col>
									</Card.Grid>
								</Card>
							</Col>
						</Space>
						<Space>
							<Col onClick={()=>{handleNaviagte('Inprogress');}} style={{marginBottom:'20px'}} span={6}> 
								<Card style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px', cursor: 'pointer'}} >
									<Card.Grid style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px',}}>
										{/* <Statistic
								title="RESOLUTIONS"
								value={totalResolved}
								precision={0}
								// valueStyle={{ color: 'blue' }}
								prefix={<BellOutlined />}
								suffix=""
							/> */}
										<Col style={{ display : 'flex', justifyContent : 'center' }}>
											<img shape="square" src={lw} alt='resolved count' style={{height : '35px'}}/>

										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px', textAlign : 'center' }}>
											<Typography>{langdata && langdata ? langdata.ACTIVEINSPECTIONS: 'ACTIVE INSPECTIONS'}</Typography>
										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px' }}>
											<Typography style={{ fontSize : '25px'}}><b> {stsData && stsData.stsdashboarddata ? stsData.stsdashboarddata.activeInspections : 0}</b> </Typography>
										</Col>
									</Card.Grid>
								</Card>
							</Col>
						</Space>
						<Space>
							<Col onClick={()=>{handleNaviagte('Completed');}} style={{marginBottom:'20px'}} span={6}> 
								<Card style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px', cursor: 'pointer'}}>
									<Card.Grid style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px',}}>
										{/* <Statistic
								title="DAY UNRESOLVED ALARMS"
								value={todayUnresolved}
								precision={0}
								// valueStyle={{ color: 'gold' }}
								prefix={<BellOutlined />}
								suffix=""
							/> */}
										<Col style={{ display : 'flex', justifyContent : 'center' }}>
											<img shape="square" src={compinsp} alt='unresolved count' style={{ height : '35px'}}/>

										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px', textAlign : 'center' }}>
											<Typography>{langdata && langdata ? langdata.COMPLETEDINSPECTIONS: 'COMPLETED INSPECTIONS'}</Typography>
										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px' }}>
											<Typography style={{ fontSize : '25px'}}><b> {stsData && stsData.stsdashboarddata ? stsData.stsdashboarddata.completedInspections : 0}</b> </Typography>
										</Col>
									</Card.Grid>
								</Card>
							</Col>
						</Space>		
				
						<Space>
							<Col onClick={()=>{handleNaviagte('missedchainages');}} style={{marginBottom:'20px'}} span={6}> 
								<Card style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px', cursor: 'pointer'}}>
									<Card.Grid style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px',}}>
										{/* <Statistic
								title="DAY UNRESOLVED ALARMS"
								value={todayUnresolved}
								precision={0}
								// valueStyle={{ color: 'gold' }}
								prefix={<BellOutlined />}
								suffix=""
							/> */}
										<Col style={{ display : 'flex', justifyContent : 'center' }}>
											<img shape="square" src={chainageicon} alt='nocoverage' style={{ height : '35px'}}/>

										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px', textAlign : 'center' }}>
											<Typography>{langdata && langdata.MISSEDCHAINANGES ? langdata?.MISSEDCHAINANGES: 'MISSED CHAINANGES'}</Typography>
										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px' }}>
											<Typography style={{ fontSize : '25px'}}><b> {stsData && stsData.stsdashboarddata ? stsData.stsdashboarddata.totalChainageDeviation : 0}</b> </Typography>
										</Col>
									</Card.Grid>
								</Card>
							</Col>
						</Space>
						<Space>
							<Col onClick={()=>{handleNaviagte('attendencedeviation');}} style={{marginBottom:'20px'}} span={6}> 
								<Card style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px', cursor: 'pointer'}}>
									<Card.Grid style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px',}}>
										{/* <Statistic
								title="DAY UNRESOLVED ALARMS"
								value={todayUnresolved}
								precision={0}
								// valueStyle={{ color: 'gold' }}
								prefix={<BellOutlined />}
								suffix=""
							/> */}
										<Col style={{ display : 'flex', justifyContent : 'center' }}>
											<img shape="square" src={attendanceicon} alt='nocoverage' style={{ height : '35px'}}/>

										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px', textAlign : 'center' }}>
											<Typography>{langdata && langdata.ATTENDANCEDEVIATION ? langdata?.ATTENDANCEDEVIATION: 'ATTENDANCE DEVIATION'}</Typography>
										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px' }}>
											<Typography style={{ fontSize : '25px'}}><b> {stsData && stsData.stsdashboarddata ? stsData.stsdashboarddata.totalAttendanceViolation : 0}</b> </Typography>
										</Col>
									</Card.Grid>
								</Card>
							</Col>
						</Space>
						<Space>
							<Col onClick={()=>{handleNaviagte('geofencedeviation');}} style={{marginBottom:'20px'}} span={6}> 
								<Card style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px', cursor: 'pointer'}}>
									<Card.Grid style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px',}}>
										{/* <Statistic
								title="DAY UNRESOLVED ALARMS"
								value={todayUnresolved}
								precision={0}
								// valueStyle={{ color: 'gold' }}
								prefix={<BellOutlined />}
								suffix=""
							/> */}
										<Col style={{ display : 'flex', justifyContent : 'center' }}>
											<img shape="square" src={geofenceicon} alt='nocoverage' style={{ height : '35px'}}/>

										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px', textAlign : 'center' }}>
											<Typography>{langdata && langdata.GEOFENCEDEVIATION ? langdata?.GEOFENCEDEVIATION: 'GEOFENCE DEVIATION'}</Typography>
										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px' }}>
											<Typography style={{ fontSize : '25px'}}><b> {stsData && stsData.stsdashboarddata ? stsData.stsdashboarddata.totalGeofenceDeviation : 0}</b> </Typography>
										</Col>
									</Card.Grid>
								</Card>
							</Col>
						</Space>
						<Space>
							<Col onClick={()=>{handleNaviagte('speedviolation');}} style={{marginBottom:'20px'}} span={6}> 
								<Card style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px', cursor: 'pointer'}}>
									<Card.Grid style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px',}}>
										{/* <Statistic
								title="DAY UNRESOLVED ALARMS"
								value={todayUnresolved}
								precision={0}
								// valueStyle={{ color: 'gold' }}
								prefix={<BellOutlined />}
								suffix=""
							/> */}
										<Col style={{ display : 'flex', justifyContent : 'center' }}>
											<img shape="square" src={speedlimiticon} alt='nocoverage' style={{ height : '35px'}}/>

										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px', textAlign : 'center' }}>
											<Typography>{langdata && langdata.SPEEDVIOLATION ? langdata?.SPEEDVIOLATION: 'SPEEDVIOLATION'}</Typography>
										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px' }}>
											<Typography style={{ fontSize : '25px'}}><b> {stsData && stsData.stsdashboarddata ? stsData.stsdashboarddata.totalSpeedViolation : 0}</b> </Typography>
										</Col>
										{/* <Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px', textAlign : 'center' }}>
											<Typography>{langdata && langdata ? langdata.REPORTS: 'REPORTS'}</Typography>
										</Col> */}
										
									</Card.Grid>
								</Card>
							</Col>
						</Space>

						<Space>
							<Col onClick={()=>{handleNaviagte('totalnosignal');}} style={{marginBottom:'20px'}} span={6}> 
								<Card style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px', cursor: 'pointer'}}>
									<Card.Grid style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px',}}>
										{/* <Statistic
								title="DAY UNRESOLVED ALARMS"
								value={todayUnresolved}
								precision={0}
								// valueStyle={{ color: 'gold' }}
								prefix={<BellOutlined />}
								suffix=""
							/> */}
										<Col style={{ display : 'flex', justifyContent : 'center' }}>
											<img shape="square" src={nosignalicon} alt='nocoverage' style={{ height : '35px'}}/>

										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px', textAlign : 'center' }}>
											<Typography>{langdata && langdata.TOTALNOSIGNAL ? langdata?.TOTALNOSIGNAL: 'TOTAL NO SIGNAL'}</Typography>
										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px' }}>
											<Typography style={{ fontSize : '25px'}}><b> {stsData && stsData.stsdashboarddata ? stsData.stsdashboarddata.totalNosignal : 0}</b> </Typography>
										</Col>
									</Card.Grid>
								</Card>
							</Col>
						</Space>

						<Space>
							<Col onClick={()=>{handleNaviagte('nosignal');}} style={{marginBottom:'20px'}} span={6}> 
								<Card style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px', cursor: 'pointer'}}>
									<Card.Grid style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px',}}>
										{/* <Statistic
								title="DAY UNRESOLVED ALARMS"
								value={todayUnresolved}
								precision={0}
								// valueStyle={{ color: 'gold' }}
								prefix={<BellOutlined />}
								suffix=""
							/> */}
										<Col style={{ display : 'flex', justifyContent : 'center' }}>
											<img shape="square" src={nosignaluser} alt='nosignaluser' style={{ height : '35px'}}/>

										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px', textAlign : 'center' }}>
											<Typography>{langdata && langdata.NOSIGNAL ? langdata?.NOSIGNAL: 'NO SIGNAL USERS'}</Typography>
										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px' }}>
											<Typography style={{ fontSize : '25px'}}><b> {count ? count : 0}</b> </Typography>
										</Col>
									</Card.Grid>
								</Card>
							</Col>
						</Space>
						
						<Space>
							<Col onClick={()=>{handleNaviagte('nodata');}} style={{marginBottom:'20px'}} span={6}> 
								<Card style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px', cursor: 'pointer'}}>
									<Card.Grid style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px',}}>
										{/* <Statistic
								title="DAY UNRESOLVED ALARMS"
								value={todayUnresolved}
								precision={0}
								// valueStyle={{ color: 'gold' }}
								prefix={<BellOutlined />}
								suffix=""
							/> */}
										<Col style={{ display : 'flex', justifyContent : 'center' }}>
											<img shape="square" src={nodata} alt='nodata' style={{ height : '35px'}}/>

										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px', textAlign : 'center' }}>
											<Typography>{langdata && langdata.NODATA ? langdata?.NODATA: 'NO DATA'}</Typography>
										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px' }}>
											<Typography style={{ fontSize : '25px'}}><b> {stsData && stsData.stsdashboarddata ? stsData.stsdashboarddata.totalNoData : 0}</b> </Typography>
										</Col>
									</Card.Grid>
								</Card>
							</Col>
						</Space>
						

						<Space>
							<Col onClick={()=>{handleNaviagte('gradereport');}} style={{marginBottom:'20px'}} span={6}> 
								<Card style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px', cursor: 'pointer'}}>
									<Card.Grid style={{minWidth:'245px', minHeight:'190px', maxWidth:'245px', maxHeight:'190px',}}>
										{/* <Statistic
								title="DAY UNRESOLVED ALARMS"
								value={todayUnresolved}
								precision={0}
								// valueStyle={{ color: 'gold' }}
								prefix={<BellOutlined />}
								suffix=""
							/> */}
										<Col style={{ display : 'flex', justifyContent : 'center' }}>
											<img shape="square" src={reporticon} alt='gradereport' style={{ height : '35px'}}/>

										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px', textAlign : 'center' }}>
											<Typography>{langdata && langdata ? langdata.REPORTS: 'REPORTS'}</Typography>
										</Col>
										<Col style={{ display : 'flex', justifyContent : 'center', marginTop : '10px' }}>
											<Typography style={{ fontSize : '25px'}}><b> {stsData && stsData.stsdashboarddata ? stsData.stsdashboarddata.totalgradeReport : 0}</b> </Typography>
										</Col>
									</Card.Grid>
								</Card>
							</Col>
						</Space>
					</Row>



				</Content>
			) : (
				<>
					<Content>
						{/* <Row
							style={{
								margin: '10px',
								paddingLeft: '10px',
								paddingRight: '10px',
								background: '#FFFFFF',
								alignItems:'center',
							}}
						>


							<Col span={10}>
								<Row>

									<Space>
										<FileSearchOutlined style={{fontSize:'30px'}}/>
									</Space>

									<Space>&nbsp;&nbsp;</Space>
					
					
									<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.ReportSTSGradeSystem ? langdata.ReportSTSGradeSystem :'Report - STS Grade System'}</Title>
								</Row>
							</Col>
							<Col style ={{justifyContent:'right', display:'flex'}} span={14} >
								<Row>
									<Col span={24}>
										<Tooltip placement="bottom" title={langdata && langdata.Filterbyregion ? langdata.Filterbyregion:'Filter by region'}>
											<Space>
												<Select Item
													showSearch
													filterOption={filterOption}
													style={{ minWidth: '240px', maxWidth:'240px', margin:'5px'}}
													placeholder={langdata && langdata.SelectRegion ? langdata.SelectRegion:'Select Region'}
													optionFilterProp="children"
													value={regionId}
													defaultValue={null}
													options={regions}
													onSelect={(e, options)=>handleSetregion(e, options)}
												/>
											</Space>
										</Tooltip>
										<Space>&nbsp;&nbsp;</Space>

										<Tooltip placement="bottom" title={langdata && langdata.Selectdate ? langdata.Selectdate:'Select date'}>
											<Space>
					
												<DatePicker allowClear={false} placeholder="Today" onChange={handleSetDate} style={{ width: '200px', margin:'5px'}} format={settingsdateformat} disabledDate={disabledDate} 
													defaultValue={state && state.data.startdatetime ? dayjs(state && state.data.startdatetime, 'DD/MM/YYYY') : dayjs(moment().format('YYYY-MM-DD'), dateFormat)}/>
											</Space>
										</Tooltip>
										<Space>&nbsp;&nbsp;</Space>
										<Space>
											<Typography>
												<Popover title={langdata && langdata.STSGradeSystem ? langdata.STSGradeSystem:'STS Grade System'}  content={infoContent} trigger="click">
													<Avatar size="small"><InfoOutlined /></Avatar>
												</Popover>
											</Typography>
										</Space>
									</Col>
								</Row>
							</Col>
							{/* </Space> 
						</Row> */}

						<Row span={24} style={{
							margin: '10px',
							paddingLeft: '10px',
							paddingRight: '10px',
							background: '#FFFFFF',
							alignItems:'center'
						}} >
							<Col span={24}>
								{ Gradedata.length > 0 ? (
									<Table 
										scroll={{
											x: 900,
										}}
										columns={columns} dataSource={Gradedata} pagination = { Gradedata.length > 0 ? grade_data_pagination : 0 }  onChange = { getGrade }/>
								)
									:
									(
										<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
									)}
							</Col>
						</Row>

					</Content>
					<Spin spinning={stsData.pending} fullscreen />
				</>
			) }

		
			

		</>
		
	);
	
}